// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import LockedColumnsController from "./locked_columns_controller"
application.register("locked-columns", LockedColumnsController)

import FloatingCtaController from "./floating_cta_controller"
application.register("floating-cta", FloatingCtaController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ScrollTo from "@stimulus-components/scroll-to"
application.register("scroll-to", ScrollTo)


import ColorModeController from "./color_mode_controller"
application.register("color-mode", ColorModeController)

import FullscreenImageController from "./fullscreen_image_controller"
application.register("fullscreen-image", FullscreenImageController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import InboxDemoController from "./inbox_demo_controller"
application.register("inbox-demo", InboxDemoController)

import VerticalTabsController from "./vertical_tabs_controller"
application.register("vertical-tabs", VerticalTabsController)

import DashboardRefreshController from "./dashboard_refresh_controller"
application.register("dashboard-refresh", DashboardRefreshController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import Dialog from "@stimulus-components/dialog"
application.register("dialog", Dialog)


import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import BillingActivationController from "./billing_activation_controller"
application.register("billing-activation", BillingActivationController)

import PlanSelectorController from "./plan_selector_controller"
application.register("plan-selector", PlanSelectorController)

import SubmitLoadingController from "./submit_loading_controller"
application.register("submit-loading", SubmitLoadingController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import SeatFormController from "./seat_form_controller"
application.register("seat-form", SeatFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DemoDialogController from "./demo_dialog_controller"
application.register("demo-dialog", DemoDialogController)

import AssistantChatController from "./assistant_chat_controller"
application.register("assistant-chat", AssistantChatController)

import CloseTabController from "./close_tab_controller"
application.register("close-tab", CloseTabController)

import WhatsappSignupController from "./whatsapp_signup_controller"
application.register("whatsapp-signup", WhatsappSignupController)

import DeskPlanSelectorController from "./desk_plan_selector_controller"
application.register("desk-plan-selector", DeskPlanSelectorController)

import MetaPagesSignupController from "./meta_pages_signup_controller"
application.register("meta-pages-signup", MetaPagesSignupController)

import FocalPointController from "./focal_point_controller"
application.register("focal-point", FocalPointController)

import SocialMediaUploaderController from "./social_media_uploader_controller"
application.register("social-media-uploader", SocialMediaUploaderController)

import SocialComposerController from "./social_composer_controller"
application.register("social-composer", SocialComposerController)

import SocialCalendarController from "./social_calendar_controller"
application.register("social-calendar", SocialCalendarController)

import SocialMediaPickerController from "./social_media_picker_controller"
application.register("social-media-picker", SocialMediaPickerController)

import WallboardClockController from "./wallboard_clock_controller"
application.register("wallboard-clock", WallboardClockController)

import WallboardFullscreenController from "./wallboard_fullscreen_controller"
application.register("wallboard-fullscreen", WallboardFullscreenController)
